import RegularDashboard from 'components/Dashboard';
import DocumentHead from 'components/DocumentHead';
import PublicGigDialog from 'components/gigs/PublicGigDialog';
import ThisWeekTodos from 'components/todos/ThisWeekToDos';
import useIsAgency from 'hooks/useIsAgency';
import useNotLoggedInRedirect from 'hooks/useNotLoggedInRedirect';
import useScrollToTop from 'hooks/useScrollToTop';

const Dashboard = () => {
  useScrollToTop();
  useNotLoggedInRedirect();

  const isAgency = useIsAgency();

  return (
    <>
      <DocumentHead>
        <title>Dashboard | GigSocial</title>
      </DocumentHead>

      {isAgency ? <ThisWeekTodos /> : <RegularDashboard />}

      <PublicGigDialog />
    </>
  );
};

export default Dashboard;
